import React from 'react'

import { useCurrentTenantConfig } from '../../../../utils/tenants'
import { useSupplierById } from '../../../selfservice/supplier/data'
import { EInvoiceDisabled } from './e-invoice-disabled'
import { EInvoiceFileUpload } from './file-upload'
import { Introduction } from './introduction'
import { Table } from './table'
import { Title } from './title'

export const EInvoiceOverview: React.FC = () => {
  const { projectId } = useCurrentTenantConfig()
  const { data: supplier, isLoading } = useSupplierById(projectId as string)

  const isEInvoiceEnabled =
    supplier?.WebEdiSettings.EInvoiceProcessSettings.IsProcessActive.Value

  if (isEInvoiceEnabled === false) return <EInvoiceDisabled />

  if (isLoading) return null

  return (
    <>
      <Title />
      <Introduction />
      <EInvoiceFileUpload />
      <Table />
    </>
  )
}
